import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { trackModVisibilityToggled } from "@src/store/slices/experienceBuilder/common/thunks/mixPanel";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

export interface SetModsHiddenPayload {
  /** The ids to act on. The previewed variation's only. */
  modificationIds: string[];
  /** Absolute, never a toggle: `true` hides, `false` shows. */
  hidden: boolean;
}

/**
 * Hide or show mods in the merchant's own preview — one via the per-row eye, or
 * a whole variation via the list header. View-only: the mods still exist, still
 * ship to shoppers, and the editor does not become unsaved.
 *
 * Both the ids and the direction come from the caller, which is what keeps a
 * click consistent with the control that was rendered. It also means a stale id
 * — left behind by a deleted mod, or belonging to another variation — cannot
 * decide which way a click goes, because callers derive direction from the
 * variation-scoped hidden set.
 */
export const setModsHidden = createAsyncThunk<void, SetModsHiddenPayload>(
  "experienceBuilder/setModsHidden",
  ({ modificationIds, hidden }, { dispatch }) => {
    if (modificationIds.length === 0) return;

    dispatch(
      experienceBuilderSlice.actions._setModsHidden({
        modificationIds,
        hidden,
      })
    );

    void dispatch(
      trackModVisibilityToggled({
        visibility: hidden ? "hidden" : "shown",
      })
    );
  }
);
